import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=d9a0ecf6&"
import script from "./Resource.vue?vue&type=script&lang=ts&"
export * from "./Resource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports